export default __webpack_public_path__ + "static/media/data.2aa4dbce.csv";